export default __webpack_public_path__ + "8176867ffd60865e956a06d814a483ad.svg";